import React from "react";
import "./serving-love.css";
import Common_title from "../../common-components/common-title/Common_title";
import { Link } from "react-router-dom";

const Serving_love = () => {
  return (
    <>
      <section className="Serving_love_sec">
        <Common_title
          title="STYLED with Love"
          subtitle="From Thread to Trend. Every Day"
        />

        <div className="container  p-0">
          <div className="row mt-4 me-0">
            <div className="col-lg-5 my-auto">
              <div className="roud_div">
                <img
                  className="roundimg"
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/home/serving/tshirt.jpg"
                  }
                  alt="round-img"
                />
              </div>
            </div>
            <div className="col-xxl-6 col-lg-7">
              <div className="contsec">
                <h6 className="greentxt">
                  Your wardrobe deserves better. Say goodbye to fast-fashion
                  compromises. Get handpicked, trendsetting apparel &
                  accessories — premium quality, honest prices, straight to your
                  closet.
                </h6>

                <div className="row my-xxl-5 my-4">
                  <div className="col-sm-6">
                    <div className="thenatdiv">
                      <div className="row">
                        <div className="col-10 ms-auto my-auto">
                          <p className="thpp">100% Sustainable Fabrics</p>
                          <img
                            className="yesicon"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/icons/yes.png"
                            }
                            alt="yesicon"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="thenatdiv">
                      <div className="row">
                        <div className="col-10 ms-auto my-auto">
                          <p className="thpp">Tailored Fit & Premium Quality</p>
                          <img
                            className="yesicon"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/icons/yes.png"
                            }
                            alt="yesicon"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <p className="evryp">
                  Discover everyday style and top-tier trends delivered right to
                  your doorstep!
                </p>

                {/* <Link to="#"><button className='knwmorebtn'>Explore Collection</button></Link> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Serving_love;
